import { BaseModal } from "../../../../atoms/base-modal";
import classnames from "classnames";
import { ProcedureEntity } from "../../../../../application/domain/procedures/procedure-entity";
import { usePdfUploaderModal } from "./use-pdf-uploader-modal";
import { UseModalType } from "../../../../../utils/custom-hooks";

type PdfUploaderModalProps = {
  uploadPDFModal: UseModalType;
  procedure: ProcedureEntity;
  updateOutputBasePDFBinary: (
    value: string,
    fileName: string,
  ) => Promise<boolean>;
};

export const PdfUploaderModal = ({
  uploadPDFModal,
  procedure,
  updateOutputBasePDFBinary,
}: PdfUploaderModalProps) => {
  const { pdf, pdfName, onSelectPdf, onClickUploadPdfSave } =
    usePdfUploaderModal(updateOutputBasePDFBinary, uploadPDFModal);
  return (
    <BaseModal
      title={
        procedure.hasPdfOutputSettingForDraft()
          ? "帳票PDFを更新"
          : "帳票PDFをアップロード"
      }
      isActive={uploadPDFModal.isActive}
      onClose={uploadPDFModal.close}
    >
      <section className="modal-card-body">
        <article className="message is-warning">
          <div className="message-body content">
            <ul className="mt-0">
              {procedure.isPublished() && (
                <li>
                  こちらの手続きは既に公開されています。ファイルの更新には十分お気をつけください。
                </li>
              )}
              <li>
                アップロードしたファイル名は一括PDF交付機能にてテナントユーザーに表示されます。
              </li>
            </ul>
          </div>
        </article>
        <div className="file has-name">
          <label className="file-label">
            <input
              className="file-input"
              type="file"
              name="resume"
              accept={"application/pdf"}
              onChange={onSelectPdf}
            />
            <span className="file-cta">
              <span className="file-icon">
                <i className="fas fa-upload" />
              </span>
              <span className="file-label">
                {pdfName ? pdfName : "ファイルを選択…"}
              </span>
            </span>
            <span className="file-name">{pdf ? "選択済み" : "未選択"}</span>
          </label>
        </div>
      </section>
      <footer className="modal-card-foot">
        <button
          className="button is-failure is-fullwidth"
          onClick={uploadPDFModal.close}
        >
          キャンセル
        </button>
        <button
          className={classnames("button is-info is-fullwidth")}
          onClick={onClickUploadPdfSave}
          disabled={!pdf}
        >
          保存する
        </button>
      </footer>
    </BaseModal>
  );
};
